import { axios } from "utils";

import { TIMEOUT_INFINITE, PUBLIC_DOC_SCANS_URL as endpoint } from "consts";

import { CreateDocScanResponse, DocCrop, DocScanFieldSortBy, DocScanJobDetail, DocScanSortOrder, DocScanType, ListDocScanFieldsResponse } from "models";

export type UpsertDocScanCropField = {
  farmDocumentScanFieldId: string;
  fieldId: string;
  crops: DocCrop[];
  seedingStart: string;
  seedingEnd: string;
  harvestStart: string;
  harvestEnd: string;
};

export type UpsertDocScanCropsPayload = {
  fields: UpsertDocScanCropField[];
};

export type UpsertDocScanCropsResponse = {
  inserted: number;
  skipped: Array<{ farmDocumentScanFieldId: string; reason: string }>;
};

export const createUserDocumentScanFromDocument = async (data: {
  file: string;
  fileType: string;
  fileName: string;
  fileHash?: string;
  year?: number;
  type: DocScanType;
}): Promise<CreateDocScanResponse> => axios.post(endpoint, { data }, { timeout: TIMEOUT_INFINITE });

export const getUserDocumentScanById = async (id: string): Promise<DocScanJobDetail> => axios.get(`${endpoint}/${id}`);

export const upsertDocScanCrops = async (docScanId: string, payload: UpsertDocScanCropsPayload): Promise<UpsertDocScanCropsResponse> =>
  axios.post(`${endpoint}/${docScanId}/upsert-crops`, payload);

export const listUserDocumentScanFields = async (data: {
  id: string;
  page: number;
  limit: number;
  sortBy: DocScanFieldSortBy;
  sortOrder: DocScanSortOrder;
  overallStatus?: string;
  excludeOverallStatus?: string;
  search?: string;
}): Promise<ListDocScanFieldsResponse> => axios.get(`${endpoint}/${data.id}/fields`, { data });
